import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import * as accountCampaignPricingEmailValidationActions from "../actions/account_campaign_pricing_email_validation_actions";
import * as accountCampaignPricingEmailValidationTypes from "../types/account_campaign_pricing_email_validation_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";
import { endpoints } from "../endpoints";

function* getPricingOfAccountEmailValidationCampaign(action) {
  try {
    const res = yield call(api.get, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_EMAIL_VALIDATION}/${action.payload.id}`);
    if (res.status === 200) {
      yield put(accountCampaignPricingEmailValidationActions.getPricingOfAccountEmailValidationCampaignSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingEmailValidationActions.getPricingOfAccountEmailValidationCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingEmailValidationActions.getPricingOfAccountEmailValidationCampaignError(e));
  }
}

function* editPricingOfAccountEmailValidationCampaign(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_CAMPAIGN_PRICING_EMAIL_VALIDATION}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(accountCampaignPricingEmailValidationActions.editPricingOfAccountEmailValidationCampaignSuccess(res.data));
      yield put(accountCampaignPricingEmailValidationActions.getPricingOfAccountEmailValidationCampaignRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(accountCampaignPricingEmailValidationActions.editPricingOfAccountEmailValidationCampaignError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(accountCampaignPricingEmailValidationActions.editPricingOfAccountEmailValidationCampaignError(e));
  }
}

export default function* accountCampaignPricingEmailValidationSaga() {
  yield takeLatest(accountCampaignPricingEmailValidationTypes.getPricingOfAccountEmailValidationCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_REQUEST, getPricingOfAccountEmailValidationCampaign);
  yield takeLatest(accountCampaignPricingEmailValidationTypes.editPricingOfAccountEmailValidationCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_VALIDATION_CAMPAIGN_REQUEST, editPricingOfAccountEmailValidationCampaign);
}
